<template>
  <v-dialog
    retain-focus
    :value="edit"
    v-on:click:outside="goToShow"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-overlay absolute :value="this.dataloading || this.loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-overlay>
      <v-card-title tabindex="-1">
        <span class="headline">Edit Product Type</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="goToShow"
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-on:submit.prevent width="100%" ref="editForm">
          <v-text-field
            :rules="validationRules.name"
            v-model="editFields.name"
            label="Product Type *"
            :error-messages="inputErrorMessages('name')"
            v-on:keyup.enter="saveProductType"
            tabindex="1"
          />
        </v-form>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="goToShow">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveProductType">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      loading: false,
      validationRules: {
        name: [
          v => !!v || this.rem('ProductType name'),
          v => !v || v.length <= 255 || 'ProductType name should not be greater than 255'
        ]
      },
      errorMessages: {},
      editFields: {
        name: ''
      }
    };
  },
  computed: {
    ...mapState({
      dataloading: state => state.ProductType.getProductTypeLoading,
      productType(state) {
        if (typeof state.ProductType.productType.data == 'undefined') {
          return {
            name: ''
          };
        }
        return state.ProductType.productType.data;
      }
    })
  },
  watch: {
    productType(value) {
      this.editFields.name = value.name;
    }
  },
  mounted() {
    this['ProductType/getProductType']({ id: this.$route.params.id }).finally(() => {
      this.editFields.name = this.$store.state.ProductType.data.productType.name;
    });
  },
  props: {
    edit: false,
    page: 0
  },
  methods: {
    ...mapActions(['ProductType/fetchProductTypes', 'ProductType/getProductType']),
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveProductType() {
      if (this.$refs.editForm.validate()) {
        this.loading = true;
        axios
          .put(`api/v1/type/${this.$route.params.id}`, this.editFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Product Type saved...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.editForm.resetValidation();
            this['ProductType/fetchProductTypes']({ page: this.page });
            this.$router.push('/producttype');
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    goToShow() {
      this.$router.push(`/producttype/${this.$route.params.id}`);
    }
  }
};
</script>